"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quote = void 0;
class Quote {
}
exports.Quote = Quote;
//# sourceMappingURL=Quote.js.map